// 6-tier discrete color system. Combined score = sqrt(adj1 * adj2), so two
// equal dots give a cell of the same value — cell and dot thresholds match.
// ⬜(<1) 🟥(1-2.5) 🟧(2.5-4) 🟨(4-6.5) 🟩(6.5-8.5) 🟦(8.5+)

export const LOADING_EMOJIS = ['\u{1F914}', '\u{1F4D8}', '\u{1F4DA}', '\u270D\uFE0F', '\u{1F4BB}'];

export function scoreToDotColor(score) {
  if (score < 1) return 'hsl(0, 0%, 80%)';
  if (score < 2.5) return 'hsl(0, 72%, 51%)';
  if (score < 4) return 'hsl(25, 95%, 53%)';
  if (score < 6.5) return 'hsl(50, 90%, 50%)';
  if (score < 8.5) return 'hsl(135, 55%, 42%)';
  return 'hsl(215, 70%, 50%)';
}

export function scoreToCellBackground(score) {
  if (score < 1) return 'hsl(0, 0%, 97%)';
  if (score < 2.5) return 'hsl(0, 60%, 95%)';
  if (score < 4) return 'hsl(30, 60%, 95%)';
  if (score < 6.5) return 'hsl(50, 60%, 95%)';
  if (score < 8.5) return 'hsl(135, 50%, 94%)';
  return 'hsl(215, 55%, 94%)';
}
